import React from "react";
import DOMPurify from "dompurify";

export default function SanitizedHtml({htmlString}: {htmlString: string}) {
  return <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(htmlString)}}/>
}